import { createSelector, createSlice } from '@reduxjs/toolkit';
import { CoreState, LoadingState } from '../interfaces/coreState';

const initialState: LoadingState = { activeCalls: 0 };

// Reducers
const slice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    incrementActiveCalls(state) {
      state.activeCalls += 1;
    },
    decrementActiveCalls(state) {
      state.activeCalls -= 1;
    }
  }
});

export default slice.reducer;

// Actions
export const { incrementActiveCalls, decrementActiveCalls } = slice.actions;

// Selectors
/** Root selector for this slice */
const getLoading = (state: CoreState) => state.core.loading;

export const getIsLoading = createSelector(
  [getLoading],
  (loading) => loading.activeCalls > 0
);
